import React, { useState } from 'react';
import SectionTitle from '../../components/SectionTitle/SectionTitle';
import './Services.scss';
import TexturePattern from '../../components/TexturePattern/TexturePattern';
import ServicesData from './ServiceData';
import Service from '../../components/Service/Service';
import { BsFillArrowRightCircleFill } from "react-icons/bs";

const Services = () => {
    const [activeCategory, setActiveCategory] = useState('All');

    // Define category order
    const categories = ['All', 'Preventive Care', 'Restorative Dentistry', 'Emergency & Pain Relief', 'Specialized Treatments'];
    
    // Filter services based on active category
    const filteredServices = activeCategory === 'All' 
        ? ServicesData 
        : ServicesData.filter(service => service.category === activeCategory);

    return (
        <section className='service-section pt-100 pb-70 position-relative' 
                 data-aos="fade-up" 
                 data-aos-duration="2000"
                 aria-labelledby="services-heading">
            <TexturePattern isFooter={false} />
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 col-sm-6">
                        <SectionTitle title="Comprehensive Dental Services in Ottery, Cape Town" subTitle="Our Services"/>
                    </div>
                    <div className="col-lg-6 col-sm-6">
                        <p className='service-title-text'>
                            At Dr. Mishqah Dollie's dental practice in Ottery, Cape Town, we offer a full range of treatments designed to keep your smile healthy and beautiful. From preventive care to advanced restorative procedures, we provide expert dental care in a calm, welcoming environment.
                        </p>
                    </div>
                </div>

                {/* Category Filter */}
                <div className="row mb-5">
                    <div className="col-12">
                        <div className="category-filter text-center" role="tablist" aria-label="Filter dental services by category">
                            {categories.map(category => (
                                <button
                                    key={category}
                                    className={`category-btn ${activeCategory === category ? 'active' : ''}`}
                                    onClick={() => setActiveCategory(category)}
                                    role="tab"
                                    aria-selected={activeCategory === category}
                                    aria-controls={`services-${category.toLowerCase().replace(/\s+/g, '-')}`}
                                >
                                    {category}
                                </button>
                            ))}
                        </div>
                    </div>
                </div>

                {/* Services Grid */}
                <div className="row" role="tabpanel" aria-labelledby={`services-${activeCategory.toLowerCase().replace(/\s+/g, '-')}`}>
                    {filteredServices.map((singleService, index) => (
                        <div key={index} className="col-lg-4 col-md-6 mb-4">
                            <Service serviceList={singleService} />
                        </div>
                    ))}
                </div>

                {/* Show message if no services in category */}
                {filteredServices.length === 0 && (
                    <div className="row">
                        <div className="col-12 text-center">
                            <p className="no-services">No services available in this category.</p>
                        </div>
                    </div>
                )}

                <div className="row">
                    <div className="col-12 text-center mt-5">
                        <p className="lead">
                            We offer a comprehensive range of dental treatments in Ottery, Cape Town, including routine check-ups, consultations, examinations, and solutions for specific dental problems. Our experienced team ensures personalized care for every patient.
                        </p>
                    </div>
                </div>
            </div>

            <div className="services-link text-center">
                <a href='https://www.recomed.co.za/dentist/cape-town/mishqah-dollie/7579/7349/' 
                   target="_blank" 
                   rel="noopener noreferrer"
                   aria-label="Book your dental appointment with Dr Mishqah Dollie in Ottery, Cape Town">
                    Book Your Appointment
                    <BsFillArrowRightCircleFill aria-hidden="true"/>
                </a>
            </div>
        </section>
    );
};

export default Services;